module.exports = __webpack_public_path__ + "img/banner.7776f1e3.png";